import CircularProgress from '@mui/material/CircularProgress';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import React from 'react';

const PREFIX = 'Loading';

const classes = {
  root: `${PREFIX}-root`,
};

const Root = styled('div')({
  [`&.${classes.root}`]: {
    width: '50%',
    maxWidth: '300px',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
});

const Loading = () => {
  const [show, setShow] = React.useState(false);

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setShow(true);
    }, 300);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Root className={clsx(classes.root)}>
      {show && (<CircularProgress size="100%" />)}
    </Root>
  );
};

export default Loading;
